import { ethers } from "ethers";
const BondingManagerABI = require("../abi/BondingManager.json");
const BondingManagerAddress = "0x35Bcf3c30594191d53231E4FF333E8A770453e40";
const LivepeerTokenABI = require("../abi/LivepeerToken.json");
const LivepeerTokenAddress = "0x289ba1701C2F088cf0faf8B3705246331cB8A839";
const RoundsManagerABI = require("../abi/RoundsManager.json");
const RoundsManagerABIAddress = "0xdd6f56DcC28D3F5f27084381fE8Df634985cc39f";

export const useBondingManager = () => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      return new ethers.Contract(BondingManagerAddress, BondingManagerABI, signer);
    }
  } catch (error) {
    console.log(error);
  }
}

export const useLivepeerToken = () => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      return new ethers.Contract(LivepeerTokenAddress, LivepeerTokenABI, signer);
    }
  } catch (error) {
    console.log(error);
  }
}

export const useRoundsManager = () => {
  try {
    const { ethereum } = window;
    if (ethereum) {
      const provider = new ethers.providers.Web3Provider(ethereum);
      const signer = provider.getSigner();
      return new ethers.Contract(RoundsManagerABIAddress, RoundsManagerABI, signer);
    }
  } catch (error) {
    console.log(error);
  }
}
